module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.displayData) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayData)
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Version Check")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d64d9936"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VersionCheck.vue
// module id = 633
// module chunks = 1